import {BaseContainerModel} from '../../base-container.model';
import { bl_crm_membership_period_line_RowClass } from '../../../dbschema/bl_crm_membership_period_line.model';

export class MembershipPeriodLineContainerModel extends BaseContainerModel {
    bl_crm_membership_period_line: bl_crm_membership_period_line_RowClass = new bl_crm_membership_period_line_RowClass();
}
